import { AnyAction } from 'redux';
import { GlobalActions, MasterProduktData } from '@ps20-frontend/shop-integration-redux';
import { App, VhvVorbelegungdaten, ZusatzoptionItem } from '@ps20-frontend/frontend-models';
import { FahrradWert, Produktlinienname } from '@ps20/bff-models';
import { FahradwertForLinie, ZUSATZOPTION_FAHRRAD_ID } from '../model/fahradwertForLinie.model';
import { VhvActions } from '../vhvActions';
import { IAppState } from '../appState';

export const versicherungssummeFahrradReducer = function (
  sectionState: Array<FahradwertForLinie> = null,
  action: AnyAction,
  state: IAppState,
): Array<FahradwertForLinie> {
  switch (action.type) {
    case GlobalActions.PRODUKT_RECEIVED: {
      const actionPayload: MasterProduktData = action.payload;

      if (actionPayload.appId !== App.VHV || action.payload.angebotsId !== state.angebotsId) {
        return sectionState;
      }

      return actionPayload.produktData.produktlinien.map(produktlinie => {
        return {
          produktlinie: produktlinie.produktName,
          summe: getDefaultFahrradWert(produktlinie.zusatzoptionen),
        };
      });
    }
    case VhvActions.VERSSUMME_FAHRRAD_CHANGED: {
      return sectionState.map(fahrradWertLinie => {
        if (fahrradWertLinie.produktlinie !== Produktlinienname.PREMIUM) {
          return {
            produktlinie: fahrradWertLinie.produktlinie,
            summe: action.payload,
          };
        }
        return { ...fahrradWertLinie };
      });
    }
    case GlobalActions.VORBELEGUNG_FOR_BEIBEHALTUNG_REQUESTED: {
      const actionPayload: VhvVorbelegungdaten = action.payload;
      if (
        actionPayload.forApp === App.VHV &&
        actionPayload.angebotsId === state.angebotsId &&
        actionPayload.fahrradWert
      ) {
        return [
          {
            produktlinie: actionPayload.produktlinienname,
            summe: actionPayload.fahrradWert,
          },
        ];
      }
      return sectionState;
    }
    case VhvActions.PRODUKT_ZUSATZOPTIONEN_VORBELEGT: {
      const relevantVorbelegungdaten: VhvVorbelegungdaten = action.payload;
      if (relevantVorbelegungdaten.fahrradWert) {
        return sectionState.map(fahradwert => {
          if (fahradwert.produktlinie !== Produktlinienname.PREMIUM) {
            fahradwert.summe = relevantVorbelegungdaten.fahrradWert;
          }
          return fahradwert;
        });
      }
      return sectionState;
    }
    default:
      return sectionState;
  }
};

function getDefaultFahrradWert(zusatzoptionen: Array<ZusatzoptionItem>): FahrradWert {
  const fahrradzusatzoption = zusatzoptionen.find(
    zusatzoption => zusatzoption.id === ZUSATZOPTION_FAHRRAD_ID,
  );

  if (fahrradzusatzoption) {
    return mapToFahrradEnum(fahrradzusatzoption.eigenschaft);
  }

  throw new Error(
    `getDefaultFahrradWert: ${ZUSATZOPTION_FAHRRAD_ID} nicht als Zusatzoption vorhanden!`,
  );
}

function mapToFahrradEnum(fahrradWert: string): FahrradWert {
  switch (fahrradWert) {
    case FahrradWert.BIS1500.toString():
      return FahrradWert.BIS1500;
    case FahrradWert.BIS3000.toString():
      return FahrradWert.BIS3000;
    case FahrradWert.BIS6000.toString():
      return FahrradWert.BIS6000;
    case FahrradWert.UEBER6000.toString():
      return FahrradWert.UEBER6000;
  }

  throw new Error(`mapToFahrradEnum: kann Wert ${fahrradWert} nicht auf FahrradWert-Enum mappen!`);
}
